import { render, staticRenderFns } from "./ChangePasswordModalPane.vue?vue&type=template&id=e825d248&"
import script from "./ChangePasswordModalPane.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordModalPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports